import { combineReducers, Reducer } from "redux";

import { EMPTY_ARRAY } from "@multiweb/reactUtils";
import { ISearchedTextChangedAction, ISearchState, ISetSearchResultsAction, SearchResult } from "./types";

export const searchedText: Reducer<string> = (state = "", action) => {
    if (action instanceof ISearchedTextChangedAction) {
        return action.payload.searchedText;
    } else {
        return state;
    }
};

export const searchResults: Reducer<ReadonlyArray<SearchResult>> = (state = EMPTY_ARRAY, action) => {
    if (action instanceof ISetSearchResultsAction) {
        return action.payload.searchResults;
    } else {
        return state;
    }
};

export const reducer: Reducer<ISearchState> = combineReducers({
    searchedText,
    searchResults,
});
